import React, { useEffect, useState } from 'react';
import { path } from 'ramda';
import { css } from 'emotion';
import { getDynamicFormContext, getDynamicFormCategories } from '../../../shared/requests-api';
import { checkoutCredentials } from "../../../shared/utils";
import CancellationCategory from './CancellationCategory';
import ModalError from '../../DynamicForm/components/ModalError';

const loadingCss = `
  box-shadow: rgba(0, 0, 0, .1) 0px 2px 1px;
  margin-bottom: 8px;
  background: #fff;
  padding: 16px;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  .loader {
    width: 33px;
    height: 33px;
  }
`;

const CancellationCategories = ({ order }) => {
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [contextToken, setContextToken] = useState(null);
  const [correlationId, setCorrelationId] = useState(null);
  const [modalError, setModalError] = useState({ open: false, correlationId: null });

  useEffect(() => {
    const token = checkoutCredentials().au;

    const getCategoriesContext = async () => {
      try {
        const context = await getDynamicFormContext(token, {
          name: "contexto-minhas-viagens",
          data: {
            providerOrderId: order.order.code
          }
        });
  
        const _categories = await getDynamicFormCategories(token, context.data.contextToken, context.headers['x-correlation-id']);
  
        setCorrelationId(context.headers['x-correlation-id']);
        setContextToken(context.data.contextToken);
        setCategories(_categories.data);
        setLoading(false);
      } catch (err) {
        setModalError({
          open: true,
          correlationId: path(['response', 'headers', 'x-correlation-id'], err)
        });
      }
    };

    getCategoriesContext();
  }, []);

  return (
    <div>
      {loading && (
        <div className={css`${loadingCss}`}>
          <i className="loader loader-fetching center-block" />
        </div>
      )}

      {!loading && (
        categories.map(category => (
          <CancellationCategory
            key={category.id}
            category={category}
            contextToken={contextToken}
            correlationId={correlationId}
          />
        ))
      )}

      {modalError.open && (
        <ModalError
          open={modalError.open}
          onClose={() => setModalError({ ...modalError, open: false })}
          correlationId={modalError.correlationId}
        />
      )}
    </div>
  )
};

export default CancellationCategories;
